import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './HomePage';
import AboutPage from './AboutPage';
import InfoPage from './InfoPage';
import OpportunitiesPage from './OpportunitiesPage';
import QueriesPage from './QueriesPage';
import TimegrapherPage from './TimegrapherPage';
import GuidesPage from './GuidesPage';
import AccuracyGuidePage from './AccuracyGuidePage';
import TimegrapherGuidePage from './TimegrapherGuidePage';
import BeatErrorPage from './BeatErrorPage';
import BrandAccuracyPage from './BrandAccuracyPage';
import MeasureAccuracyPage from './MeasureAccuracyPage';
import WatchRunningFastPage from './WatchRunningFastPage';
import AccuracyReportsPage from './AccuracyReportsPage';
import AnalyticsPage from './AnalyticsPage';
import WatchReportPage from './WatchReportPage';
import CollectionReportPage from './CollectionReportPage';
import ReportLookupPage from './ReportLookupPage';
import { initPostHog } from './config/posthog';

function App() {
  // Initialize PostHog when the app starts
  useEffect(() => {
    initPostHog();
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/info" element={<InfoPage />} />
        <Route path="/opportunities" element={<OpportunitiesPage />} />
        <Route path="/queries" element={<QueriesPage />} />
        <Route path="/timegrapher" element={<TimegrapherPage />} />
        <Route path="/guides" element={<GuidesPage />} />
        <Route path="/accuracy" element={<AccuracyGuidePage />} />
        <Route path="/what-is-a-timegrapher" element={<TimegrapherGuidePage />} />
        <Route path="/beat-error" element={<BeatErrorPage />} />
        <Route path="/brand-accuracy" element={<BrandAccuracyPage />} />
        <Route path="/measure-watch-accuracy" element={<MeasureAccuracyPage />} />
        <Route path="/watch-running-fast" element={<WatchRunningFastPage />} />
        <Route path="/analytics" element={<AnalyticsPage />} />
        <Route path="/analytics/lookup" element={<ReportLookupPage />} />
        <Route path="/r/:token" element={<CollectionReportPage />} />
        <Route path="/r/:token/w/:watchId" element={<WatchReportPage />} />
        <Route path="/accuracy-reports" element={<AccuracyReportsPage />} />
        <Route path="/report-example" element={<CollectionReportPage demo />} />
        <Route path="/report-example/w/:watchId" element={<WatchReportPage demo />} />
        <Route path="/analytics/:userId" element={<CollectionReportPage />} />
        <Route path="/analytics/:userId/:watchId" element={<WatchReportPage />} />
      </Routes>
    </Router>
  );
}

export default App; 